import { useState, useEffect } from "react";

import { AllGameFinishedScreen } from "../../components/AllGameFinishedScreen";
import { GameView } from "../../components/GameView";
import { integrationApi } from "../../main";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";
import { GameVisualsProvider } from "../../contexts/gameVisuals";
import { ProjectNicknameModal } from "../../components/shared/NicknameModal";
import { ProjectLeaderboardView } from "../../components/LeaderboardView/ProjectLeaderboardView";

import styles from "./ProjectPage.module.scss";

export const ProjectPage = () => {
  const {
    games,
    hideSummaryPage,
    showLeaderboard,
    leaderboardConfiguration,
    projectNickname,
    setProjectNickname,
    projectId,
  } = useGlobalConfiguration();
  const [finishedGameIds, setFinishedGameIds] = useState<string[]>([]);
  const gamesToPlay = games.filter((game) => !finishedGameIds.includes(game.id));
  const currentGameConfiguration = gamesToPlay[0];

  const isLeaderboardVisible = showLeaderboard && !projectNickname;

  const finishGame = (gameId: string) => {
    setFinishedGameIds([...finishedGameIds, gameId]);
  };

  useEffect(() => {
    if (gamesToPlay.length === 0) {
      integrationApi.showNativeControls();
      integrationApi.clickNextButton();
      return;
    }
  }, [gamesToPlay.length]);

  if (gamesToPlay.length > 0) {
    return (
      <div className={styles.appContainer}>
        <ProjectNicknameModal
          projectId={projectId}
          isOpen={isLeaderboardVisible}
          onContinue={setProjectNickname}
          configuration={leaderboardConfiguration}
        />
        <GameVisualsProvider gameVisuals={currentGameConfiguration.configuration.gameVisuals}>
          <GameView game={currentGameConfiguration} finishGame={finishGame} key={currentGameConfiguration.id} />
        </GameVisualsProvider>
      </div>
    );
  }
  if (showLeaderboard) {
    return <ProjectLeaderboardView />;
  }

  if (!hideSummaryPage) {
    return <AllGameFinishedScreen />;
  }

  return null;
};
